import { localStorageColorSchemeManager } from "@mantine/core";

export const colorSchemeStorageKey = "hittapodd-color-scheme";

export const colorSchemeManager = localStorageColorSchemeManager({
    key: colorSchemeStorageKey,
});
